import React, { memo } from 'react';
import { Flex } from '@adobe/react-spectrum';
import rowStyles from 'app/components/RoadmapCard/Row.module.scss';
import { MonthlyTimelineMonthsBody } from './MonthlyTimelineMonthsBody';
import { MonthlyRow } from './MonthlyRow';
import type {
  DayColumnDescriptor,
  MonthDescriptor,
  MonthlyTimelineLane
} from '../utils/types';

interface MonthlyTimelineRowProps {
  lane: MonthlyTimelineLane;
  months: MonthDescriptor[];
  expandedMonths: string[];
  dayColumns: DayColumnDescriptor[];
  getDayLeftPx: (monthKey: string, day: number) => number | null;
  bodyWidthPx: number;
  columnsWidthPx: number;
  gapWidth: number;
  mustWinRowKey?: string;
}

function formatLaneLabel(label: string) {
  const parts = label.split('/');

  return (
    <div className={rowStyles.text}>
      {parts.map((part, index) => (
        <span key={index}>
          {part}
          {index < parts.length - 1 && <br />}
        </span>
      ))}
    </div>
  );
}

export const MonthlyTimelineRow = memo(
  ({
    lane,
    months,
    expandedMonths,
    dayColumns,
    getDayLeftPx,
    bodyWidthPx,
    columnsWidthPx,
    gapWidth,
    mustWinRowKey
  }: MonthlyTimelineRowProps) => {
    const laneTestId = lane.label.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();

    return (
      <Flex
        direction="row"
        UNSAFE_style={{ minWidth: 'max-content' }}
        data-testid={`monthly-timeline-row-${laneTestId}`}
      >
        <div
          data-testid={`monthly-row-header-${laneTestId}`}
          className={rowStyles.gridHeader}
        >
          <div
            className={rowStyles.heading}
            data-testid={`monthly-row-heading-${laneTestId}`}
          >
            {formatLaneLabel(lane.label)}
          </div>
        </div>

        <Flex data-testid={`monthly-row-quarters-${laneTestId}`}>
          <MonthlyTimelineMonthsBody
            months={months}
            dayColumns={dayColumns}
            expandedMonths={expandedMonths}
            bodyWidthPx={bodyWidthPx}
            columnsWidthPx={columnsWidthPx}
          >
            <MonthlyRow
              lane={lane}
              months={months}
              getDayLeftPx={getDayLeftPx}
              bodyWidthPx={bodyWidthPx}
              mustWinRowKey={mustWinRowKey}
            />
          </MonthlyTimelineMonthsBody>

          <div
            className={rowStyles.whiteGapFiller}
            style={{ width: gapWidth ? `${gapWidth}px` : undefined }}
          />
        </Flex>
      </Flex>
    );
  }
);
